const envDomain = "cyberskiller.com";

export const environment = {
  displayedDomain: `alk.${envDomain}`,
  production: true,
  apiLocation: "/api/",
  apiDomain: `https://api.${envDomain}`,
  wsLocation: `wss://api.${envDomain}/ws/`,
  judge0ApiLocation: `https://judge.${envDomain}/`,
  captchaMocked: false,
  defaultLang: "pl",
  langKey: "ALK",
  sentryDsn: "https://f80798483a5e4c589b040b22cd8f25d3@glitchtip.cyberskiller.com/2",
  sentryEnvironment: "prod",
  sentryTracesSampleRate: 0.02,
};
